import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Container,
  TopInfoWrapper,

} from './styles'
import { Button, ModalVariables, Table, TopProgress } from '../../../../components'
import { icons } from '../../../../icons'
import { useNavigate, useParams } from 'react-router-dom'
import { loadBalancerService, networkService } from '../../../../api'
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { useUi } from '../../../../context/ui.context'
import { handleStatusName } from '../../../../utils/handle-status-name'
import { StateWrapper, GreenDot, Greentext } from '../../../Instances/styles'
import { permissionSurfaces, usePermission, usePermissionDecision } from '../../../../permissions';

const Pools:FC = () => {
  const [t] = useTranslation()
  const {poolId, lbId} = useParams()
  const {viewAlert} = useUi()
  const navigate = useNavigate()
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const [pools, setPools] = useState<any[]>([])
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>()
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [deletedPort, setDeletedPort] = useState<any>()
  const { mergeEntityPermissions } = usePermission()
  const canCreateMember = usePermissionDecision(permissionSurfaces.pageActions.poolMemberCreate).allowed


  const _updateMembers = () => {
    //@ts-ignore
    loadBalancerService.getPoolMembers(poolId)
    .then((res) => {
      mergeEntityPermissions('loadBalancers', res.data, 'Merged member list permissions')
      setPools(res.data.objects.map((member:any) => {
        return{
          ...member,
          name:member.name || 'n/a',
          navigate: `/load-balancer-pool/${lbId}/${poolId}/members/${member.id}`,
          admin_state_up:member.admin_state_up ? 'Yes' : 'No',
          backup: member.backup ? 'Yes' : 'No',
          operating_status: 
            (<StateWrapper>
              <GreenDot active={member.operating_status}/>
              <Greentext active={member.operating_status}>
                {handleStatusName(member.operating_status, t)}
              </Greentext>
            </StateWrapper>),
          provisioning_status: 
            (<StateWrapper>
              <GreenDot active={member.provisioning_status}/>
              <Greentext active={member.provisioning_status}>
                {handleStatusName(member.provisioning_status, t)}
              </Greentext>
            </StateWrapper>),
        }
      }))
      setPageLoading(false)
      setLoading(false)
    })
  }
  const _deletePorts = async () => {
    setLoading(true)
    if(!poolId) return
    try{
      await loadBalancerService.deleteMember(poolId, deletedPort.id)
      await viewAlert({
        severity:'info',
        message:`${t("MEMBER_DELETED_SUCCESSFULLY")}`
      })
      await _updateMembers()
    } catch (e:any) {
      if(e?.response?.data.detail){
        viewAlert({
          severity:'error',
          message:e?.response?.data?.detail ||`${t("ERROR_OCCURRED")}`,
        })
      }
      _updateMembers()
      setPageLoading(false)
      setLoading(false)
    } finally {
      setViewModal(false)
      setActiveAnimation(false)
    }
  }
  useEffect(() => {
    _updateMembers()
    const interval = setInterval(() => {
      _updateMembers()
    },10000)
    return () => clearInterval(interval)
  },[])
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const closeModal = (props:any) => {
    _deletePorts()
  }
  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }
  const items = [
    {
      title:t("EDIT"),
      id:'2',
      icon:icons.Edit,
      permissionSurface: permissionSurfaces.rowActions.memberEdit,
      onClick: (member:any) => navigate(`${member.id}/edit`),
      divider:false
    },
    {
      title:t("DELETE"),
      id:'4',
      permissionSurface: permissionSurfaces.rowActions.memberDelete,
      onClick:(id:any) => {
        openModal('delete')
        setAlertTitle(t("MEMBER_DELETE"))
        setAlertSubTitle([id])
        setDeletedPort(id)
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]
  const Columns = [
    {
      title:t("NAME"),
      key:'name'
    },
    {
      title:t("IP_ADDRESS"),
      key:'address',
    },
    {
      title:t("PORT"),
      key:'protocol_port'
    },
    {
      title:t("WEIGHT"),
      key:'weight'
    },
    {
      title:t("BACKUP"),
      key:'backup'
    },
    {
      title:t("OPERATING_STATUS"),
      key:'operating_status'
    },
    {
      title:t("PROVISIONING_STATUS"),
      key:'provisioning_status'
    },
    {
      title:t("ADMIN_STATE_UP"),
      key:'admin_state_up'
    },
    {
      title:'',
      key:'props'
    },
  ]
  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <Container>
      <TopProgress loading={loading}/>
      <TopInfoWrapper>
        <div style={{display:'flex', marginBottom:'20px'}}>
          {canCreateMember ?
          <Button
            variant="primary"
            size="display"
            onClick={() => navigate(`create`)}
            title={t("CREATE_NEW_MEMBER")}
            customStyles={{marginRight:'10px'}}
          />
          : null}
        </div>
      </TopInfoWrapper>
        <Table
          columns={Columns}
          rows={pools}
          settings={items}
          hideOther
          hideCheckbox
        />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        // dataToEdit={editedSubnet}
        loading={loading}
      />
    </Container>
  )
}
export default Pools
